module.exports = __webpack_public_path__ + "img/Sosnoff.0c625f4c.png";